module.exports = __webpack_public_path__ + "asset/image-icon-image-aff2af5657ab6cfd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/scene/calendar/component/calendar-day/component/calendar-day-event/image/icon-image.svg
// module id = cxal
// module chunks = 0